/* tslint:disable */
/* eslint-disable */
/**
 * FOPkasa.Web
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import globalAxios, { AxiosResponse, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { PointOfSaleResponse } from '../models';
/**
 * PointOfSaleApi - axios parameter creator
 * @export
 */
export const PointOfSaleApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [partnerUid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPointOfSaleForPartnerGet: async (partnerUid?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/PointOfSale/for-partner`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (partnerUid !== undefined) {
                localVarQueryParameter['partnerUid'] = partnerUid;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPointOfSaleGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/PointOfSale`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PointOfSaleApi - functional programming interface
 * @export
 */
export const PointOfSaleApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [partnerUid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPointOfSaleForPartnerGet(partnerUid?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<Array<PointOfSaleResponse>>>> {
            const localVarAxiosArgs = await PointOfSaleApiAxiosParamCreator(configuration).apiPointOfSaleForPartnerGet(partnerUid, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPointOfSaleGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<Array<PointOfSaleResponse>>>> {
            const localVarAxiosArgs = await PointOfSaleApiAxiosParamCreator(configuration).apiPointOfSaleGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * PointOfSaleApi - factory interface
 * @export
 */
export const PointOfSaleApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} [partnerUid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPointOfSaleForPartnerGet(partnerUid?: string, options?: AxiosRequestConfig): Promise<AxiosResponse<Array<PointOfSaleResponse>>> {
            return PointOfSaleApiFp(configuration).apiPointOfSaleForPartnerGet(partnerUid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPointOfSaleGet(options?: AxiosRequestConfig): Promise<AxiosResponse<Array<PointOfSaleResponse>>> {
            return PointOfSaleApiFp(configuration).apiPointOfSaleGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PointOfSaleApi - object-oriented interface
 * @export
 * @class PointOfSaleApi
 * @extends {BaseAPI}
 */
export class PointOfSaleApi extends BaseAPI {
    /**
     * 
     * @param {string} [partnerUid] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PointOfSaleApi
     */
    public async apiPointOfSaleForPartnerGet(partnerUid?: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<Array<PointOfSaleResponse>>> {
        return PointOfSaleApiFp(this.configuration).apiPointOfSaleForPartnerGet(partnerUid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PointOfSaleApi
     */
    public async apiPointOfSaleGet(options?: AxiosRequestConfig) : Promise<AxiosResponse<Array<PointOfSaleResponse>>> {
        return PointOfSaleApiFp(this.configuration).apiPointOfSaleGet(options).then((request) => request(this.axios, this.basePath));
    }
}
